import { render, staticRenderFns } from "./UnvergessenTooltip.vue?vue&type=template&id=3d94e1d2"
import script from "./UnvergessenTooltip.vue?vue&type=script&lang=js"
export * from "./UnvergessenTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports